import { render, staticRenderFns } from "./exercisegrouplist.vue?vue&type=template&id=2b95a318&scoped=true"
import script from "./exercisegrouplist.vue?vue&type=script&lang=js"
export * from "./exercisegrouplist.vue?vue&type=script&lang=js"
import style0 from "./exercisegrouplist.vue?vue&type=style&index=0&id=2b95a318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b95a318",
  null
  
)

export default component.exports